import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn, H6, P } from "../../../../../AbstractElements";
import CardHeaderCommon from "../../../../../Utils/CommonComponents/CardHeaderCommon";
import { ClipBoardCopy, CopyHighLightedText, CopyPortionFromParagraphs, HighlightText } from "../../../../../Utils/Constants";

const CopyPortionFromParagraph = () => {
  const [highlightTextValue, setHighlightTextValue] = useState("Web design is the process of creating websites");
  const handleCopy = async () => {
    await navigator.clipboard.writeText(highlightTextValue);
    setHighlightTextValue(highlightTextValue);
  };
  return (
    <Col sm="12" md="6">
      <Card>
        <CardHeaderCommon title={CopyPortionFromParagraphs} />
        <CardBody>
          <div className="clipboaard-container">
            <P className="card-description">{ClipBoardCopy}</P>
            <H6 className="border rounded card-body f-w-300">
              <span className="bg-primary text-white p-1">{HighlightText}</span>
              that are visible online. Take a website design course to learn how to create an appealing and responsive website. In the discipline of web design, there are degree, diploma, postgraduate degree, and certificate programmes. A web designer is responsible for a website's look, feel, and occasionally even content.
            </H6>
            <div className="mt-3 text-end">
              <Btn className="btn-clipboard" color="secondary" onClick={handleCopy}>
                <i className="fa fa-copy"></i> {CopyHighLightedText}
              </Btn>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CopyPortionFromParagraph;
